import { Component, OnInit } from '@angular/core';
import {Credentials} from "../models/credentials";
import {LocalDataService} from "../services/local-data.service";
import {Router} from "@angular/router";
import {PublicationsService} from "../services/publications.service";
import {ObservablepostService} from "../services/observablepost.service";
import {LocationModel} from "../models/location.model";
import {server, km, logo} from "../services/index.path";
import {Post} from "../models/post.model";
import { CredentialsService } from '../nservices/login/credentials.service';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  username?:string;
  no_access_field:boolean = false;


  constructor(private _router:Router,private _publicationsS:PublicationsService,
              private _credentialsS:CredentialsService) {
    if (this._credentialsS.getCredentialsAnonymous()) {
      this.username = this._credentialsS.getCredentialsAnonymous().anonymous;
      this.no_access_field = this._credentialsS.getCredentialsAnonymous().ishidden;
    }
    else{
      this.username = this._credentialsS.getCredentialsUser().username;
    }

  }

  ngOnInit() {
    //console.log("ngOnInit del header");
  }

  logout(){
    if (confirm("¿Estas seguro de cerrar sesion?")) {
      this._credentialsS.makeLogout();
      this._router.navigate(['login']);
    }
  }

  goToNewPost(){
    this._router.navigate(['newPost']);
  }

  goToMyPost(){
    this._router.navigate(['mypublications']);
  }


}



// WEBPACK FOOTER //
// C:/Users/CLAUDIA/Desktop/Timeplacebook2/src/app/header/header.component.ts